import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Flower2 } from "lucide-react";
import { site } from "../../config/site";
import { scrollToSection as scrollTo } from "./lenis";

const Label = ({ children, color }) => (
  <span
    className="inline-flex items-center rounded-full border border-white/10 bg-[#0d0d0d]/90 backdrop-blur-md px-3.5 py-1.5 text-xs font-semibold shadow-[0_6px_20px_rgba(0,0,0,0.4)]"
    style={{ color }}
  >
    {children}
  </span>
);

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3"
        >
          {/* Call Us */}
          <div className="flex items-center gap-2">
            <Label color="#53C653">Call Us</Label>
            <a
              href={site.phoneHref || undefined}
              onClick={(e) => { if (!site.phoneHref) { e.preventDefault(); scrollTo("quote"); } }}
              data-testid="fab-call"
              aria-label="Call us now"
              className="relative h-14 w-14 rounded-full bg-[#53C653] flex items-center justify-center text-white shadow-[0_0_25px_rgba(83,198,83,0.5)]"
            >
              <span className="absolute inset-0 rounded-full bg-[#53C653] animate-ping opacity-40" />
              <Phone size={22} className="relative" />
            </a>
          </div>

          {/* Get A Quote */}
          <div className="flex items-center gap-2">
            <Label color="#F56FB4">Get A Quote</Label>
            <button
              onClick={() => scrollTo("quote")}
              data-testid="fab-quote"
              aria-label="Get a free quote"
              className="h-14 w-14 rounded-full bg-[#F56FB4] flex items-center justify-center text-white shadow-[0_0_25px_rgba(245,111,180,0.5)] transition-transform duration-200 hover:scale-110"
            >
              <Flower2 size={24} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingActions;
